



// *****   vzc notifications par emails *****
// src/components/Payment/MonerisPayment.jsx
import React, { useEffect, useRef, useState } from "react";
import { Button, Alert, Spin } from "antd";
import { CreditCardOutlined, CheckCircleOutlined } from "@ant-design/icons";
import createMonerisTicket from '../../services/course.service';
import axios from 'axios';
import courseService from '../../services/course.service';


const SDK_SRC_QA   = "https://gatewayt.moneris.com/chktv2/js/chkt_v2.01.js";
const SDK_SRC_PROD = "https://gateway.moneris.com/chkt/js/chkt_v2.01.js";
const USE_PROD = true;

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const MonerisPayment = ({ course, onSuccess, onError, autoStart = false }) => {
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [sdkReady, setSdkReady] = useState(!!window.monerisCheckout);
  const [ticket, setTicket] = useState(null);
  const containerRef = useRef(null);

  // Charge le SDK une seule fois
  useEffect(() => {
    if (window.monerisCheckout) {
      setSdkReady(true);
      return;
    }
    const script = document.createElement("script");
    script.src = USE_PROD ? SDK_SRC_PROD : SDK_SRC_QA;
    script.async = true;
    script.onload = () => setSdkReady(true);
    script.onerror = () => setErr("❌ Erreur de chargement du SDK Moneris");
    document.body.appendChild(script);
  }, []);

  // Démarre automatiquement si demandé
  useEffect(() => {
    if (autoStart && sdkReady && !ticket && !loading) {
      startPayment();
    }
  }, [autoStart, sdkReady]);

  // Démarre automatiquement si demandé
useEffect(() => {
  if (autoStart && sdkReady && !ticket && !loading) {
    startPayment();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [autoStart, sdkReady, ticket, loading]);

  const startPayment = async () => {
    setErr("");
    setLoading(true);

    try {
      if (typeof window.monerisCheckout === "undefined") {
        throw new Error("SDK Moneris non chargé !");
      }

      // 1) Créer le ticket côté backend
      const resp = await createMonerisTicket.createMonerisTicket({
        course,
        amount: course?.latest_price || course?.price || 0,
      });
      
      const t = resp?.ticket || resp?.data?.ticket;
      if (!t) throw new Error("Ticket Moneris introuvable");
      
      console.log("🎫 Ticket créé:", t);
      setTicket(t);

      // 2) Démarrer le Checkout Moneris
      const checkout = new window.monerisCheckout();
      checkout.setMode(USE_PROD ? "prod" : "qa");
      checkout.setCheckoutDiv("moneris-checkout");

      // ✅ CALLBACK CRITIQUE : Vérifier et sauvegarder le paiement
    // Remplacez le callback payment_complete par payment_receipt
checkout.setCallback("payment_receipt", async (data) => {
  console.log("========================================");
  console.log("CALLBACK PAYMENT_RECEIPT DÉCLENCHÉ !");
  console.log("Data:", data);
  console.log("Ticket:", t);
  console.log("========================================");
  
  try {
    await handlePaymentSuccess(t);
  } catch (error) {
    console.error("ERREUR DANS handlePaymentSuccess:", error);
  }
});

// Gardez aussi les autres callbacks
checkout.setCallback("cancel_transaction", () => {
  console.warn("Paiement annulé");
  setErr("Paiement annulé par l'utilisateur");
  onError && onError(new Error("Paiement annulé"));
});

checkout.setCallback("error_event", (error) => {
  console.error("Erreur Moneris:", error);
  setErr("Erreur lors du paiement");
  onError && onError(error);
});

// Ajoutez aussi ce callback pour voir tous les événements
checkout.setCallback("page_loaded", () => {
  console.log("Page Moneris chargée");
});

      checkout.startCheckout(t);
    } catch (e) {
      console.error("❌ Erreur paiement Moneris", e);
      setErr(e?.message || "Erreur lors du paiement");
      onError && onError(e);
    } finally {
      setLoading(false);
    }
  };

  /**
   * 🔥 FONCTION CRITIQUE : Vérifie et traite le paiement côté backend
   */

  /**
 * Vérifie et traite le paiement côté backend avec retry
 */
// const handlePaymentSuccess = async (ticketId, retryCount = 0) => {
//   const MAX_RETRIES = 5;
//   const DELAY_MS = 2000; // 2 secondes entre chaque tentative

//   setProcessing(true);
//   setErr("");

//   try {
//     // Récupérer userId
//     let userId = localStorage.getItem('userId');
    
//     if (!userId) {
//       userId = sessionStorage.getItem('userId');
//     }
    
//     if (!userId) {
//       const userStr = localStorage.getItem('user');
//       if (userStr) {
//         const user = JSON.parse(userStr);
//         userId = user.id;
//       }
//     }
    
//     if (!userId) {
//       throw new Error("Utilisateur non identifié. Veuillez vous reconnecter.");
//     }

//     console.log(`🔍 Tentative ${retryCount + 1}/${MAX_RETRIES} - Vérification du paiement...`, {
//       ticketId,
//       userId,
//       courseId: course.id
//     });

//     // ⏱️ Attendre un peu avant la première tentative
//     if (retryCount === 0) {
//       console.log("⏱️ Attente de 3 secondes pour que Moneris finalise...");
//       await new Promise(resolve => setTimeout(resolve, 3000));
//     }

//     // Appel API backend
//     const response = await axios.post(
//       `${API_BASE_URL}/api/payments/moneris/verify-and-process`,
//       {
//         ticketId: ticketId,
//         userId: parseInt(userId),
//         courseId: course.id
//       },
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${localStorage.getItem('token')}`
//         }
//       }
//     );

//     console.log("📦 Réponse backend:", response.data);

//     // ✅ Vérifier si le paiement est approuvé
//     if (response.data.success && response.data.data.purchase) {
//       console.log("🎉 Achat enregistré avec succès:", response.data.data.purchase);
      
//       onSuccess && onSuccess({
//         ticket: ticketId,
//         purchase: response.data.data.purchase,
//         verification: response.data.data.verification
//       });
//     } 
//     // ⚠️ Si DECLINED et contient "not complete", réessayer
//     else if (
//       response.data.data?.verification?.status === "DECLINED" &&
//       response.data.data?.verification?.message?.includes("not complete") &&
//       retryCount < MAX_RETRIES
//     ) {
//       console.log(`⏳ Transaction pas encore finalisée, réessai dans ${DELAY_MS/1000}s...`);
//       await new Promise(resolve => setTimeout(resolve, DELAY_MS));
//       return handlePaymentSuccess(ticketId, retryCount + 1);
//     }
//     // ❌ Sinon, échec définitif
//     else {
//       throw new Error(response.data.message || "Paiement non approuvé");
//     }

//   } catch (error) {
//     console.error("❌ Erreur vérification paiement:", error);
    
//     // Réessayer en cas d'erreur réseau
//     if (retryCount < MAX_RETRIES && error.code === 'ECONNABORTED') {
//       console.log(`⏳ Erreur réseau, réessai dans ${DELAY_MS/1000}s...`);
//       await new Promise(resolve => setTimeout(resolve, DELAY_MS));
//       return handlePaymentSuccess(ticketId, retryCount + 1);
//     }
    
//     setErr(error.response?.data?.message || error.message || "Erreur lors de la vérification du paiement");
//     onError && onError(error);
//   } finally {
//     if (retryCount === 0 || retryCount >= MAX_RETRIES) {
//       setProcessing(false);
//     }
//   }
// };



// Import en haut du fichier

// Dans handlePaymentSuccess, remplacez l'appel axios par :
const handlePaymentSuccess = async (ticketId, retryCount = 0) => {
  const MAX_RETRIES = 5;
  const DELAY_MS = 2000;

  setProcessing(true);
  setErr("");

  try {
    // Récupérer userId
    let userId = localStorage.getItem('userId');
    
    if (!userId) {
      userId = sessionStorage.getItem('userId');
    }
    
    if (!userId) {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        userId = user.id;
      }
    }
    
    if (!userId) {
      throw new Error("Utilisateur non identifié. Veuillez vous reconnecter.");
    }

    console.log(`Tentative ${retryCount + 1}/${MAX_RETRIES} - Vérification du paiement...`);

    if (retryCount === 0) {
      console.log("Attente de 3 secondes pour que Moneris finalise...");
      await new Promise(resolve => setTimeout(resolve, 3000));
    }

    // Appel via le service
    const response = await courseService.verifyAndProcessMonerisPayment(
      ticketId,
      userId,
      course.id
    );

    console.log("Réponse backend:", response);

    if (response.success && response.data.purchase) {
      console.log("Achat enregistré avec succès:", response.data.purchase);
      
      onSuccess && onSuccess({
        ticket: ticketId,
        purchase: response.data.purchase,
        verification: response.data.verification
      });
    } 
    else if (
      response.data?.verification?.status === "DECLINED" &&
      response.data?.verification?.message?.includes("not complete") &&
      retryCount < MAX_RETRIES
    ) {
      console.log(`Transaction pas encore finalisée, réessai dans ${DELAY_MS/1000}s...`);
      await new Promise(resolve => setTimeout(resolve, DELAY_MS));
      return handlePaymentSuccess(ticketId, retryCount + 1);
    }
    else {
      throw new Error(response.message || "Paiement non approuvé");
    }

  } catch (error) {
    console.error("Erreur vérification paiement:", error);
    
    if (retryCount < MAX_RETRIES && error.code === 'ECONNABORTED') {
      console.log(`Erreur réseau, réessai dans ${DELAY_MS/1000}s...`);
      await new Promise(resolve => setTimeout(resolve, DELAY_MS));
      return handlePaymentSuccess(ticketId, retryCount + 1);
    }
    
    setErr(error.response?.data?.message || error.message || "Erreur lors de la vérification du paiement");
    onError && onError(error);
  } finally {
    if (retryCount === 0 || retryCount >= MAX_RETRIES) {
      setProcessing(false);
    }
  }
};
  return (
    <div>
      {/* Bandeau d'information */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 12,
          padding: 12,
          background: '#fff',
          border: '1px solid #eef0f3',
          borderRadius: 12,
          boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
        }}
      >
        <div style={{ fontSize: 20 }}>💳</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>Paiement sécurisé — Moneris</div>
          <div style={{ fontSize: 12, color: '#6b7280' }}>
            Cartes Visa / Mastercard / Interac. Chiffrement SSL/TLS.
          </div>
        </div>
        <Button
          type="primary"
          icon={<CreditCardOutlined />}
          onClick={startPayment}
          loading={loading}
          disabled={processing}
        >
          {loading ? "Préparation…" : ticket ? "Relancer" : "Payer maintenant"}
        </Button>
      </div>

      {/* Message d'erreur */}
      {err && (
        <Alert
          type="error"
          message="Paiement Moneris"
          description={err}
          style={{ marginBottom: 12 }}
          showIcon
          closable
          onClose={() => setErr("")}
        />
      )}

      {/* Message de traitement */}
      {processing && (
        <Alert
          type="info"
          message="Traitement en cours"
          description={
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Spin size="small" />
              <span>Vérification du paiement et enregistrement de l'achat...</span>
            </div>
          }
          style={{ marginBottom: 12 }}
          showIcon
          icon={<CheckCircleOutlined />}
        />
      )}

      {/* Zone d'intégration du formulaire Moneris */}
      <div
        id="moneris-checkout"
        ref={containerRef}
        style={{
          width: "100%",
          minHeight: 560,
          border: "1px dashed #cfd6e4",
          borderRadius: 16,
          background: "#fff",
          boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
          padding: 12,
        }}
      />

      {/* Pied de page */}
      <div style={{ textAlign: 'center', color: '#6b7280', fontSize: 12, marginTop: 10 }}>
        Besoin d'aide ? Contact : <strong>+212 661 571 360</strong>
      </div>
    </div>
  );
};

export default MonerisPayment;